Object.defineProperty(exports, "__esModule", { value: true });
exports.TableauEntityType = void 0;
var TableauEntityType;
(function (TableauEntityType) {
    TableauEntityType["USER"] = "USER";
    TableauEntityType["WORKBOOK"] = "WORKBOOK";
    TableauEntityType["VIEW"] = "VIEW";
    TableauEntityType["DATASOURCE"] = "DATASOURCE";
    TableauEntityType["FLOW"] = "FLOW";
    TableauEntityType["COMMENT"] = "COMMENT";
    TableauEntityType["DATA_ALERT"] = "DATA_ALERT";
    TableauEntityType["SUBSCRIPTION"] = "SUBSCRIPTION";
    TableauEntityType["PROJECT"] = "PROJECT";
    TableauEntityType["CUSTOMIZED_VIEW"] = "CUSTOMIZED_VIEW";
    TableauEntityType["BACKGROUND_JOB"] = "BACKGROUND_JOB";
    TableauEntityType["TASK"] = "TASK";
    TableauEntityType["FLOW_DRAFT"] = "FLOW_DRAFT";
    TableauEntityType["DATA_CONNECTION"] = "DATA_CONNECTION";
    TableauEntityType["METRIC"] = "METRIC";
    TableauEntityType["PUBLISHED_CONNECTION"] = "PUBLISHED_CONNECTION";
    TableauEntityType["COLLECTION"] = "COLLECTION";
    TableauEntityType["PUBLISHED_CONNECTION_REVISION"] = "PUBLISHED_CONNECTION_REVISION";
})(TableauEntityType = exports.TableauEntityType || (exports.TableauEntityType = {}));
//# sourceMappingURL=TableauEntityType.js.map